<div class="modal-backdrop" (click)="onClose()"></div>

<div class="modal modern-modal">

  <!-- Header -->
  <div class="modal-header">
    <div>
      <h2>{{ isEdit ? 'Edit Invoice' : 'Upload Invoice' }}</h2>
      <p class="sub-text">{{ isEdit ? 'Update invoice details below' : 'Upload and map invoice details' }}</p>
    </div>
    <span class="icon-btn" (click)="onClose()">
      <i class="fas fa-times"></i>
    </span>
  </div>

  <form (ngSubmit)="onSubmit()" #form="ngForm" style="display:flex; flex-direction:column; flex:1; min-height:0; overflow:hidden;">

    <div class="modal-body">

      <!-- Form for Create/Edit -->
      <div *ngIf="mode === 'create'">

        <div class="grid-2">
          <div class="form-group">
            <label>Invoice Number</label>
            <input type="text" [(ngModel)]="invoice.invoice_no" name="invoice_no" placeholder="Enter invoice number" />
          </div>
          <div class="form-group">
            <label>Amount (₹) <span class="hint">(auto-calculated from items)</span></label>
            <input type="number" [(ngModel)]="invoice.amount" name="amount" placeholder="0" />
            <div class="error" *ngIf="fieldErrors['amount']">{{fieldErrors['amount']}}</div>
          </div>
        </div>

        <!-- Retailer -->
        <div class="form-group">
          <label>Retailer <span class="required">*</span></label>
          <div class="autocomplete">
            <input type="text" [(ngModel)]="retailerSearchTerm" (input)="searchRetailers(retailerSearchTerm)"
              name="retailer_search" placeholder="Search retailer..." (focus)="showRetailerDropdown = true" />

            <div *ngIf="showRetailerDropdown" class="dropdown">
              <div *ngFor="let ret of filteredRetailers" (mousedown)="selectRetailer(ret)" class="dropdown-item">
                {{ret.retailer_name}}
              </div>
              <div *ngIf="filteredRetailers.length === 0" class="empty">
                No retailers found
              </div>
            </div>
          </div>
          <div *ngIf="selectedRetailerName" class="selected-chip">
            ✔ {{selectedRetailerName}}
          </div>
          <div class="error" *ngIf="fieldErrors['retailer_id']">
            {{fieldErrors['retailer_id']}}
          </div>
        </div>

        <div class="grid-2">
          <div class="form-group">
            <label>Order Date <span class="required">*</span></label>
            <input type="date" [(ngModel)]="invoice.order_date" name="order_date" />
            <div class="error" *ngIf="fieldErrors['order_date']">{{fieldErrors['order_date']}}</div>
          </div>
          <div class="form-group">
            <label>Due Date <span class="required">*</span></label>
            <input type="date" [(ngModel)]="invoice.due_date" name="due_date" />
            <div class="error" *ngIf="fieldErrors['due_date']">{{fieldErrors['due_date']}}</div>
          </div>
        </div>

        <div class="grid-2">
          <div class="form-group">
            <label>Payment Type <span class="required">*</span></label>
            <select [(ngModel)]="invoice.payment_type" name="payment_type" class="form-input">
              <option *ngFor="let type of paymentTypes" [value]="type">{{type | titlecase}}</option>
            </select>
            <div class="error" *ngIf="fieldErrors['payment_type']">{{fieldErrors['payment_type']}}</div>
          </div>
          <div class="form-group">
            <label>Payment Status</label>
            <select [(ngModel)]="invoice.payment_status" name="payment_status" class="form-input">
              <option *ngFor="let status of paymentStatuses" [value]="status">{{status | titlecase}}</option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label>Amount Paid (₹)</label>
          <input type="number" [(ngModel)]="invoice.amount_paid" name="amount_paid" placeholder="0" min="0" />
          <div class="error" *ngIf="fieldErrors['amount_paid']">{{fieldErrors['amount_paid']}}</div>
        </div>

        <!-- Items Section -->
        <div class="items-section">
          <div class="items-header">
            <label>Products / Items <span class="required">*</span></label>
            <button type="button" class="btn-add-item" (click)="addItem()">
              <i class="fas fa-plus"></i> Add Item
            </button>
          </div>
          <div class="error" *ngIf="fieldErrors['items']">{{fieldErrors['items']}}</div>

          <div *ngIf="invoice.items.length === 0" class="empty-items">
            No items added yet. Click "Add Item" to start.
          </div>

          <div class="item-row" *ngFor="let item of invoice.items; let i = index">
            <div class="item-fields">
              <div class="item-field-name">
                <label class="item-label">Product Name</label>
                <input type="text" [(ngModel)]="item.name" [name]="'item_name_' + i"
                  placeholder="Product name" (ngModelChange)="onItemChange()" />
                <div class="error" *ngIf="fieldErrors['item_name_' + i]">{{fieldErrors['item_name_' + i]}}</div>
              </div>
              <div class="item-field-qty">
                <label class="item-label">Qty</label>
                <input type="number" [(ngModel)]="item.qty" [name]="'item_qty_' + i"
                  min="1" placeholder="1" (ngModelChange)="onItemChange()" />
                <div class="error" *ngIf="fieldErrors['item_qty_' + i]">{{fieldErrors['item_qty_' + i]}}</div>
              </div>
              <div class="item-field-price">
                <label class="item-label">Price (₹)</label>
                <input type="number" [(ngModel)]="item.price" [name]="'item_price_' + i"
                  min="0" placeholder="0" (ngModelChange)="onItemChange()" />
                <div class="error" *ngIf="fieldErrors['item_price_' + i]">{{fieldErrors['item_price_' + i]}}</div>
              </div>
              <div class="item-field-total">
                <label class="item-label">Subtotal</label>
                <span class="item-subtotal">₹{{ (item.qty * item.price) | number:'1.2-2' }}</span>
              </div>
            </div>
            <button type="button" class="btn-remove-item" (click)="removeItem(i)" title="Remove item">
              <i class="fas fa-trash"></i>
            </button>
          </div>

          <div *ngIf="invoice.items.length > 0" class="items-total">
            <span>Total Amount:</span>
            <span class="total-value">₹{{ invoice.amount | number:'1.2-2' }}</span>
          </div>
        </div>

        <!-- Terms (only for new creation) -->
        <div class="form-group terms-group" *ngIf="!isEdit">
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="invoice.terms_and_conditions_accepted" name="terms_and_conditions_accepted" />
            I accept the terms and conditions
          </label>
          <div class="error" *ngIf="fieldErrors['terms_and_conditions_accepted']">
            {{fieldErrors['terms_and_conditions_accepted']}}
          </div>
        </div>

      </div>

      <!-- File Upload (Modern Dropzone) - Only for non-edit upload mode -->
      <div class="upload-card" *ngIf="mode === 'upload'">
        <label>Invoice File</label>

        <div class="upload-box" (click)="fileInput.click()">
          <input #fileInput type="file" (change)="onFileChange($event)" name="upload_file"
            accept="application/pdf,image/*" hidden />

          <div *ngIf="!selectedFileName" class="upload-placeholder">
            <div class="upload-icon">📄</div>
            <p><span>Browse file</span></p>
            <small>PDF, JPG, PNG supported</small>
          </div>

          <div *ngIf="selectedFileName" class="file-preview">
            <span>📎 {{selectedFileName}}</span>
            <span type="button" (click)="removeFile($event)">x</span>
          </div>
        </div>

        <div class="error" *ngIf="fieldErrors['upload_file']">
          {{fieldErrors['upload_file']}}
        </div>
      </div>

      <!-- Global Error -->
      <div *ngIf="errorMsg" class="error-msg">{{errorMsg}}</div>

    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="secondary" type="button" (click)="onClose()">Cancel</button>
      <button class="primary" type="submit" [disabled]="submitting">
        <span *ngIf="submitting"><i class="fas fa-spinner fa-spin"></i></span>
        {{ isEdit ? 'Update Invoice' : (mode === 'upload' ? 'Upload Invoice' : 'Create Invoice') }}
      </button>
    </div>

  </form>
</div>